import { render, staticRenderFns } from "./closePriceaddOrEdit.vue?vue&type=template&id=40d37ed8&scoped=true&"
import script from "./closePriceaddOrEdit.vue?vue&type=script&lang=js&"
export * from "./closePriceaddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./closePriceaddOrEdit.vue?vue&type=style&index=0&id=40d37ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d37ed8",
  null
  
)

export default component.exports